import React, { useEffect, useState } from "react";
import logo from "../../../img/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Header/Header.css";
import { useDispatch } from "react-redux";
import { userView } from "../../../Helper/Redux/API";
import { toast } from "react-toastify";
function Header() {
  const history = useNavigate();
  const dispatch = useDispatch();
  const user_Role = localStorage.getItem("UserName");
  const user_Lastname = localStorage.getItem("lastName");
  const testcheck = localStorage.getItem("testtrue");
  const { pathname } = useLocation();

  let loggedIn = false;

  // Jwt token
  const jwtToken = localStorage.getItem("access_token");
  let token = jwtToken;

  if (token) {
    loggedIn = true;
  }
  const UserName = localStorage.getItem("UserName");
  const LastName = localStorage.getItem("lastName");
  const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("UserName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("step2");
    localStorage.removeItem("step3");
    localStorage.removeItem("step4");
    localStorage.removeItem("step5");
    localStorage.removeItem("step6");
    localStorage.removeItem("step7");
    localStorage.removeItem("step8");
    localStorage.removeItem("step9");
    localStorage.removeItem("Rightear2KHz");
    localStorage.removeItem("Rightear4KHz");
    localStorage.removeItem("Leftear1KHz");
    localStorage.removeItem("Leftear6KHz");
    localStorage.removeItem("Measuretest");
    localStorage.removeItem("Roleid");
    localStorage.removeItem("id");
    localStorage.removeItem("result_test_id");
    localStorage.removeItem("Rightear500Hz");
    localStorage.removeItem("rightear1KHz");
    localStorage.removeItem("Leftear500Hz");
    localStorage.removeItem("Leftear2000KHz");
    localStorage.removeItem("UserName");
    localStorage.removeItem("LastName");
    // localStorage.removeItem("testtrue");
    history("/");
  };

  const [intintialValue, setInitialValue] = useState({
    name: "",
  });

  const getviewuser = () => {
    const data = {
      id: localStorage.getItem("id"),
    };
    try {
      dispatch(userView(data)).then((res) => {
        if (res?.payload?.status === true) {
          setInitialValue({
            name: `${res?.payload?.data.first_name} ${
              res?.payload?.data.last_name ? res?.payload?.data.last_name : ""
            }`,
          });
        }

        if (res?.payload?.is_active == false) {
          toast.error(res?.payload?.message);
          logout();
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    const jwtToken = localStorage.getItem("access_token");

    if (jwtToken) {
      getviewuser();
    } else {
      console.log("No access token found");
      // Handle the absence of access_token here, such as redirecting to login
    }
  }, []);

  return (
    <>
      <div className="top_bar">
        <p className="">
          Call at +65 6474 2216 &nbsp; &nbsp; &nbsp; &nbsp; WhatsApp at +65 9776
          7615 for an appointment!
        </p>
      </div>
      <div className="navbar_section">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            <Link
              className="navbar-brand wow  slideInLeft animated mr-0"
              to="/"
            >
              <img src={logo} className="img-fluid" alt="logo" />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse justify-content-end"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav align-items-center wow  fadeInUp animated">
                <li
                  className={pathname == '/' ? "active nav-item " : "nav-item"}
                >
                  <Link to="/" className="nav-link" aria-current="page">
                    HOME
                  </Link>
                </li>

                <li
                  className={
                    pathname.includes("About")
                      ? "active nav-item "
                      : "nav-item "
                  }
                >
                  <Link to="/About" className="nav-link" aria-current="page">
                    About Us
                  </Link>
                </li>

                <li
                  className={
                    pathname.includes("/Services/")
                      ? "active nav-item dropdown"
                      : "nav-item dropdown"
                  }
                >
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDarkDropdownMenuLink"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Services
                  </a>
                  <ul
                    class="dropdown-menu dropdown-menu-dark"
                    aria-labelledby="navbarDarkDropdownMenuLink"
                  >
                    <li>
                      <Link
                        class="dropdown-item"
                        to="/Services/Hearing-Services"
                      >
                        Hearing Tests
                      </Link>
                    </li>
                    <li>
                      <Link
                        class="dropdown-item"
                        to="/Services/Hearing-Implants"
                      >
                        Hearing Implants
                      </Link>
                    </li>

                    <li>
                      <Link
                        class="dropdown-item"
                        to="/Services/Ear-Measurements"
                      >
                        Ear Measurements
                      </Link>
                    </li>
                    <li>
                      <Link
                        class="dropdown-item"
                        to="/Services/hearing-aid-repairs-and-adjustments"
                      >
                        Repairs & Adjustments
                      </Link>
                    </li>
                  </ul>
                </li>

                <li
                  className={
                    pathname.includes("/Products/")
                      ? "active nav-item dropdown"
                      : "nav-item dropdown"
                  }
                >
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDarkDropdownMenuLink"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Products
                  </a>
                  <ul
                    class="dropdown-menu dropdown-menu-dark"
                    aria-labelledby="navbarDarkDropdownMenuLink"
                  >
                    <li>
                      <Link class="dropdown-item" to="/Products/Phonak-Hearing">
                        Phonak Hearing Aids
                      </Link>
                    </li>
                    <li>
                      <Link
                        class="dropdown-item"
                        to="/Products/signia-hearing-aids-the-hearing-centre-singapore"
                      >
                        Signia Hearing Aids
                      </Link>
                    </li>

                    <li>
                      <Link
                        class="dropdown-item"
                        to="/Products/resound-hearing-aid"
                      >
                        ReSound Hearing Aids
                      </Link>
                    </li>
                    <li>
                      <Link
                        class="dropdown-item"
                        to="/Products/starkey-hearing-aids"
                      >
                        Starkey Hearing Aids
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={
                    pathname.includes("Testimonials")
                      ? "active nav-item "
                      : "nav-item "
                  }
                >
                  <Link
                    to="/Testimonials"
                    className="nav-link"
                    aria-current="page"
                  >
                    Testimonials
                  </Link>
                </li>
                <li
                  className={
                    pathname.includes("FAQ") ? "active nav-item " : "nav-item "
                  }
                >
                  <Link className="nav-link" to="/FAQ">
                    FAQs
                  </Link>
                </li>
                <li
                  className={
                    pathname.includes("Blogs") ? "active nav-item " : "nav-item "
                  }
                >
                  <a className="nav-link" >
                    Blogs
                  </a>
                </li>
                <li
                  className={
                    pathname.includes("/contact")
                      ? "active nav-item "
                      : "nav-item "
                  }
                >
                  <Link className="nav-link" to="/contact">
                    Contact us
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    target="__blank"
                    to="https://development.cppatidar.com/hearing/login"
                  >
                    Admin Login
                  </Link>
                </li>
                <li className="nav-item">
                  {!loggedIn ? (
                    <>
                      {" "}
                      <Link
                        className="nav-link"
                        aria-current="page"
                        to="/Login"
                      >
                        Sign In
                      </Link>
                    </>
                  ) : (
                    // <>
                    //   <Link
                    //     className="nav-link"
                    //     aria-current="page"
                    //     to="/Calendar"
                    //   >
                    //     Dashboard
                    //   </Link>
                    // </>
                    ""
                  )}
                </li>
                {loggedIn ? (
                  <>
                    <li className="nav-item">
                      <div class="dropdown">
                        <button
                          class="btn btn-secondary dropdown-toggle"
                          type="button"
                          id="Top_header"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span>
                            {" "}
                            {UserName ? UserName : ""}&nbsp;
                            {LastName ? LastName : ""}
                          </span>
                          {/* <img src={user} className="img-fluid" alt="user_img" /> */}
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="Top_header">
                          <li>
                            <Link
                              class="dropdown-item"
                              aria-current="page"
                              to="/Calendar"
                            >
                              Dashboard
                            </Link>
                          </li>
                          <li>
                            <Link class="dropdown-item" onClick={logout}>
                              Logout
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </>
                ) : (
                  ""
                )}

                {/* {testcheck != "1" && (
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      aria-current="page"
                      // target="_blank"
                      to="/Heartest"
                    >
                      <button className="btn">Online hearing test</button>
                    </Link>
                  </li>
                )} */}

                {/* {loggedIn ? ( */}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    aria-current="page"
                    // target="_blank"
                    to="/Heartest"
                  >
                    <button className="btn">Online hearing test</button>
                  </Link>
                </li>
                {/* ) : (
                  ""
                )} */}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Header;
